import Radio from 'backbone.radio';
import './index.styl';
import template from './index.jst';
import { Tipping as GameBarModel } from '../../models';
import { View } from 'backbone.marionette';
import { isMobile } from '../../utils';

import {
	TippingTipsDetails,
	TippingTipsControls
} from '../components';

const
	tippingRadio = Radio.channel('tipping');

export default class Gamebar extends View {
	get template() {
		return template;
	}

	regions() {
		return {
			tips_info: '.tips-info',
			tips_controls: '.tips-controls'
		}
	}

	className() {
		return 'tipping-tips-gamebar';
	}

	initialize() {
		this.getRegion('tips_info').show(new TippingTipsDetails({
			model: new GameBarModel()
		}));

		this.getRegion('tips_controls').show(new TippingTipsControls());

		this.listenTo(tippingRadio, 'tips:round:change', this.isShowCalculate)
	}

	isShowCalculate( status ) {
		if( status === 'complete' ) {
			$('.gamebar').css('display', 'none');
		}
		else {
			if(isMobile()){
				$('.gamebar').css('bottom', '62px');
			}
			$('.gamebar').css('display', 'flex');
		}
	}
}